export const removeParagraphTag = (txt: string): string =>
  txt.replace(/<\/?p[^>]*>/g, '');
